if (!customElements.get('kivo-home-faq-support')) {
  customElements.define(
    'kivo-home-faq-support',
    class KivoHomeFaqSupport extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.items = Array.from(this.querySelectorAll('.kivo-home-08-faq-support__item'));
        this.handleSummaryClick = this.handleSummaryClick.bind(this);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.items.forEach((item) => {
          const summary = item.querySelector('.kivo-home-08-faq-support__summary');
          const answer = item.querySelector('.kivo-home-08-faq-support__answer');

          if (!summary) return;

          summary.addEventListener('click', this.handleSummaryClick);
          summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');

          if (answer?.id) {
            summary.setAttribute('aria-controls', answer.id);
          }
        });

        this.closeDuplicateDefaultItems();
      }

      disconnectedCallback() {
        this.items?.forEach((item) => {
          const summary = item.querySelector('.kivo-home-08-faq-support__summary');
          summary?.removeEventListener('click', this.handleSummaryClick);
          this.finishAnimation(item, item.open);
        });
      }

      closeDuplicateDefaultItems() {
        const openItems = this.items.filter((item) => item.open);

        openItems.slice(1).forEach((item) => {
          item.open = false;
          this.setExpanded(item, false);
        });
      }

      handleSummaryClick(event) {
        const item = event.currentTarget.closest('.kivo-home-08-faq-support__item');

        if (!item) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (item.open) {
          this.closeItem(item);
          return;
        }

        this.items.forEach((otherItem) => {
          if (otherItem !== item && otherItem.open) {
            this.closeItem(otherItem);
          }
        });

        this.openItem(item);
      }

      openItem(item) {
        this.finishAnimation(item, item.open);

        const startHeight = item.getBoundingClientRect().height;
        item.style.height = `${startHeight}px`;
        item.open = true;
        item.classList.add('is-animating', 'is-opening');
        this.setExpanded(item, true);

        const openHeight = this.getCssPixelValue(item, '--kivo-home-08-open-height');
        const targetHeight = Math.max(item.scrollHeight, openHeight);

        if (this.reducedMotion.matches) {
          this.finishAnimation(item, true);
          return;
        }

        this.animateHeight(item, targetHeight, true);
      }

      closeItem(item) {
        this.finishAnimation(item, item.open);

        const startHeight = item.getBoundingClientRect().height;
        item.style.height = `${startHeight}px`;
        item.classList.add('is-animating', 'is-closing');
        this.setExpanded(item, false);

        const targetHeight = this.getCssPixelValue(item, '--kivo-home-08-closed-height');

        if (this.reducedMotion.matches) {
          this.finishAnimation(item, false);
          return;
        }

        this.animateHeight(item, targetHeight, false);
      }

      animateHeight(item, targetHeight, shouldStayOpen) {
        const complete = (event) => {
          if (event.target !== item || event.propertyName !== 'height') return;
          this.finishAnimation(item, shouldStayOpen);
        };

        item._kivoHome08TransitionEnd = complete;
        item._kivoHome08TransitionTimer = window.setTimeout(() => this.finishAnimation(item, shouldStayOpen), 420);
        item.addEventListener('transitionend', complete);

        requestAnimationFrame(() => {
          item.style.height = `${targetHeight}px`;
        });
      }

      finishAnimation(item, shouldBeOpen) {
        if (item._kivoHome08TransitionEnd) {
          item.removeEventListener('transitionend', item._kivoHome08TransitionEnd);
          item._kivoHome08TransitionEnd = null;
        }

        if (item._kivoHome08TransitionTimer) {
          window.clearTimeout(item._kivoHome08TransitionTimer);
          item._kivoHome08TransitionTimer = null;
        }

        item.open = shouldBeOpen;
        item.style.height = '';
        item.classList.remove('is-animating', 'is-opening', 'is-closing');
        this.setExpanded(item, shouldBeOpen);
      }

      setExpanded(item, isExpanded) {
        const summary = item.querySelector('.kivo-home-08-faq-support__summary');
        summary?.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      }

      getCssPixelValue(item, propertyName) {
        const value = window.getComputedStyle(item).getPropertyValue(propertyName);
        const parsedValue = Number.parseFloat(value);

        return Number.isFinite(parsedValue) ? parsedValue : 0;
      }
    }
  );
}
